// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { PersonnelsNotFlatResponse } from "@/services";

export const userMock: PersonnelsNotFlatResponse = {
  LoaWorkers: [
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "111111111",
      WorkerEmiratesId: "WorkerEmiratesId",
      WorkerFirstName: "WorkerFirstName",
      WorkerLastName: "WorkerLastName",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "WorkerFullNameEnglish",
      WorkerNationality: "WorkerNationality",
      WorkerPassportNumber: "123",
      WorkerJobTitle: "test",
      CompanyAr: "Company Example name",
      ResidencyAr: "ResidencyAr",
      WorkerJobTitleArabic: "WorkerJobTitleArabic",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 0,
      WorkerOnboardingStatusComments:
        "[Worker is not Active][ failed][ has no Expiry date][ has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "470001635212345",
      WorkerEmiratesId: "",
      WorkerFirstName: "MM_PRC_1",
      WorkerLastName: "CONSULTANT",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "470001635212345",
      WorkerNationality: "IND",
      WorkerPassportNumber: "470001635212345",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2023-12-31T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2023-12-31T00:00:00",
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 0,
      WorkerOnboardingStatusComments:
        "[Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "923165865180000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Lay",
      WorkerLastName: "O'Dooghaine",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Lay O'Dooghaine",
      WorkerNationality: "TUR",
      WorkerPassportNumber: "803674295",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "533339012599190",
      WorkerEmiratesId: "",
      WorkerFirstName: "Bret",
      WorkerLastName: "Jerman",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Bret Jerman",
      WorkerNationality: "TUR",
      WorkerPassportNumber: "812476490",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "574064321876930",
      WorkerEmiratesId: "",
      WorkerFirstName: "Harli",
      WorkerLastName: "Leverette",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Harli Leverette",
      WorkerNationality: "KOR",
      WorkerPassportNumber: "475749643",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "233485195300000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Lucky",
      WorkerLastName: "Vigrass",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Lucky Vigrass",
      WorkerNationality: "CAN",
      WorkerPassportNumber: "319589876",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "374283038407011",
      WorkerEmiratesId: "",
      WorkerFirstName: "Ros",
      WorkerLastName: "Quarrell",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Ros Quarrell",
      WorkerNationality: "IRL",
      WorkerPassportNumber: "886482740",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2025-07-29T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2025-07-04T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2025-01-01T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Worker is not Active][Medical Fitness failed]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "893034546580000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Kellia",
      WorkerLastName: "Canti",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Kellia Canti",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "348833047",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "540530953917750",
      WorkerEmiratesId: "",
      WorkerFirstName: "Mignonne",
      WorkerLastName: "Cleveland",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Mignonne Cleveland",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "307923828",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "718984310780000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Chrissy",
      WorkerLastName: "Dowglass",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Chrissy Dowglass",
      WorkerNationality: "PHL",
      WorkerPassportNumber: "678355037",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "550242404830100",
      WorkerEmiratesId: "",
      WorkerFirstName: "Eulalie",
      WorkerLastName: "Druhan",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Eulalie Druhan",
      WorkerNationality: "MEX",
      WorkerPassportNumber: "506173894",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "585896895180650",
      WorkerEmiratesId: "",
      WorkerFirstName: "Rochelle",
      WorkerLastName: "Kneesha",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Rochelle Kneesha",
      WorkerNationality: "IND",
      WorkerPassportNumber: "371407294",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "553783616235730",
      WorkerEmiratesId: "",
      WorkerFirstName: "Karlis",
      WorkerLastName: "Cummine",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Karlis Cummine",
      WorkerNationality: "IRL",
      WorkerPassportNumber: "573441911",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "334449844629970",
      WorkerEmiratesId: "",
      WorkerFirstName: "Adrien",
      WorkerLastName: "Dainton",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Adrien Dainton",
      WorkerNationality: "MEX",
      WorkerPassportNumber: "376365039",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "580559245445720",
      WorkerEmiratesId: "",
      WorkerFirstName: "Idell",
      WorkerLastName: "Struijs",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Idell Struijs",
      WorkerNationality: "PHL",
      WorkerPassportNumber: "254787108",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "224177817995000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Hortensia",
      WorkerLastName: "MacDonald",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Hortensia MacDonald",
      WorkerNationality: "AUS",
      WorkerPassportNumber: "490181859",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "534934025003590",
      WorkerEmiratesId: "",
      WorkerFirstName: "Lyndel",
      WorkerLastName: "Killen",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Lyndel Killen",
      WorkerNationality: "COL",
      WorkerPassportNumber: "437174910",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "844078773469930",
      WorkerEmiratesId: "",
      WorkerFirstName: "Livia",
      WorkerLastName: "Treadger",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Livia Treadger",
      WorkerNationality: "GBR",
      WorkerPassportNumber: "824864426",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "314169215908000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Allistir",
      WorkerLastName: "Lackner",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Allistir Lackner",
      WorkerNationality: "IRL",
      WorkerPassportNumber: "895655954",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "222566204921000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Robin",
      WorkerLastName: "Fishburn",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Robin Fishburn",
      WorkerNationality: "CAN",
      WorkerPassportNumber: "413457842",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "759231254545810",
      WorkerEmiratesId: "",
      WorkerFirstName: "Natala",
      WorkerLastName: "Dally",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Natala Dally",
      WorkerNationality: "ITA",
      WorkerPassportNumber: "185149794",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "548820554148730",
      WorkerEmiratesId: "",
      WorkerFirstName: "Bordy",
      WorkerLastName: "Breinl",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Bordy Breinl",
      WorkerNationality: "PHL",
      WorkerPassportNumber: "621566493",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "706674233236120",
      WorkerEmiratesId: "",
      WorkerFirstName: "Gun",
      WorkerLastName: "Goldster",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gun Goldster",
      WorkerNationality: "BRA",
      WorkerPassportNumber: "131783751",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "575259228279460",
      WorkerEmiratesId: "",
      WorkerFirstName: "Gerry",
      WorkerLastName: "Laughrey",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gerry Laughrey",
      WorkerNationality: "NGA",
      WorkerPassportNumber: "722411502",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "126588761831000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Kleon",
      WorkerLastName: "Matasov",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Kleon Matasov",
      WorkerNationality: "CHL",
      WorkerPassportNumber: "779606590",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "108756002312350",
      WorkerEmiratesId: "",
      WorkerFirstName: "Romola",
      WorkerLastName: "Rampling",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Romola Rampling",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "129137220",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "483757070951000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Terri",
      WorkerLastName: "Dyott",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Terri Dyott",
      WorkerNationality: "AUT",
      WorkerPassportNumber: "180832649",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2026-11-24T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2024-02-08T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2024-03-07T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Worker is not Active][Medical Fitness failed]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "223053470808100",
      WorkerEmiratesId: "",
      WorkerFirstName: "Tadeo",
      WorkerLastName: "McGreil",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Tadeo McGreil",
      WorkerNationality: "GBR",
      WorkerPassportNumber: "651490600",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "537089752858580",
      WorkerEmiratesId: "",
      WorkerFirstName: "Anderea",
      WorkerLastName: "Flipek",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Anderea Flipek",
      WorkerNationality: "CHL",
      WorkerPassportNumber: "842127266",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "471850922995010",
      WorkerEmiratesId: "",
      WorkerFirstName: "Heywood",
      WorkerLastName: "Glandfield",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Heywood Glandfield",
      WorkerNationality: "ESP",
      WorkerPassportNumber: "127603561",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "583320807816940",
      WorkerEmiratesId: "",
      WorkerFirstName: "Haydon",
      WorkerLastName: "Rozanski",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Aurelia Moreno",
      WorkerNationality: "AUT",
      WorkerPassportNumber: "180832649",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "331104981695400",
      WorkerEmiratesId: "",
      WorkerFirstName: "Abie",
      WorkerLastName: "McElvine",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gray Reed",
      WorkerNationality: "IRL",
      WorkerPassportNumber: "886482740",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "374283038407011",
      WorkerEmiratesId: "",
      WorkerFirstName: "Loise",
      WorkerLastName: "Degoe",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Loise Degoe",
      WorkerNationality: "IRL",
      WorkerPassportNumber: "180401628",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "483757070951000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Anastasia",
      WorkerLastName: "Swale",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Anastasia Swale",
      WorkerNationality: "AUT",
      WorkerPassportNumber: "862278972",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "550999344990400",
      WorkerEmiratesId: "",
      WorkerFirstName: "Clarita",
      WorkerLastName: "Dobbson",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Lacey Soto",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "355099934",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2024-01-31T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2024-02-29T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2024-04-26T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Worker is not Active][Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "333246722610130",
      WorkerEmiratesId: "",
      WorkerFirstName: "Aldus",
      WorkerLastName: "Dekeyser",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Luke Kim",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "633324672",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "580765817917940",
      WorkerEmiratesId: "",
      WorkerFirstName: "Gracia",
      WorkerLastName: "Morfield",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gracia Morfield",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "580765817",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "586343006828890",
      WorkerEmiratesId: "",
      WorkerFirstName: "Sashenka",
      WorkerLastName: "Thorouggood",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Sashenka Thorouggood",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "586343006",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "570917478731230",
      WorkerEmiratesId: "",
      WorkerFirstName: "Alaster",
      WorkerLastName: "Boyes",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Durante MacCauley",
      WorkerNationality: "PAK",
      WorkerPassportNumber: "570917478",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "180763269374650",
      WorkerEmiratesId: "",
      WorkerFirstName: "Carlen",
      WorkerLastName: "Wilbor",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gracia Morfield",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "180763269",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "580260605072550",
      WorkerEmiratesId: "",
      WorkerFirstName: "Cyndia",
      WorkerLastName: "Craigs",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Sashenka Thorouggood",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "580260605",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2023-10-31T00:00:00",
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "844237150598000",
      WorkerEmiratesId: "",
      WorkerFirstName: "Tallie",
      WorkerLastName: "Knevett",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gracia Morfield",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "844237150",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2023-07-22T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2023-12-08T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2024-02-28T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "574948870861570",
      WorkerEmiratesId: "",
      WorkerFirstName: "Matthiew",
      WorkerLastName: "Kettleson",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Sashenka Thorouggood",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "574948870",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2024-01-02T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2023-07-22T00:00:00",
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "110147000000325",
      WorkerEmiratesId: "",
      WorkerFirstName: "Tobey",
      WorkerLastName: "Chavez",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Tobey Chavez",
      WorkerNationality: "SWE",
      WorkerPassportNumber: "226110147",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "162982510929761",
      WorkerEmiratesId: "",
      WorkerFirstName: "Burg",
      WorkerLastName: "Vickors",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Burg Vickors",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "591629825",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "205123000000342",
      WorkerEmiratesId: "",
      WorkerFirstName: "Antony",
      WorkerLastName: "Iorizzi",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Antony Iorizzi",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "520512312",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "778612442163846",
      WorkerEmiratesId: "",
      WorkerFirstName: "Ariana",
      WorkerLastName: "De Mitri",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Ariana De Mitri",
      WorkerNationality: "PAK",
      WorkerPassportNumber: "284778612",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "130779819520281",
      WorkerEmiratesId: "",
      WorkerFirstName: "Gunther",
      WorkerLastName: "Ingerman",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gunther Ingerman",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "232130779",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "282925420687725",
      WorkerEmiratesId: "",
      WorkerFirstName: "Denis",
      WorkerLastName: "Rapper",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Denis Rapper",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "728292542",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "223584161861621",
      WorkerEmiratesId: "",
      WorkerFirstName: "Elmer",
      WorkerLastName: "Arenson",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Elmer Arenson",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "322358000",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "589357141583373",
      WorkerEmiratesId: "",
      WorkerFirstName: "Sibilla",
      WorkerLastName: "Gownge",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Sibilla Gownge",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "258935710",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2024-04-19T00:00:00",
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "498161454129138",
      WorkerEmiratesId: "",
      WorkerFirstName: "Adella",
      WorkerLastName: "Setterfield",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Adella Setterfield",
      WorkerNationality: "PAK",
      WorkerPassportNumber: "498100000",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "120663691202242",
      WorkerEmiratesId: "",
      WorkerFirstName: "Shay",
      WorkerLastName: "Digby",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Shay Digby",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "120660000",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "532048036393110",
      WorkerEmiratesId: "",
      WorkerFirstName: "Jeremiah",
      WorkerLastName: "Leonardi",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Jeremiah Leonardi",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "036393110",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "558910892415140",
      WorkerEmiratesId: "",
      WorkerFirstName: "Werner",
      WorkerLastName: "Gyrgorwicx",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Werner Gyrgorwicx",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "892415140",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "574141763564090",
      WorkerEmiratesId: "",
      WorkerFirstName: "Gus",
      WorkerLastName: "Harborow",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Gus Harborow",
      WorkerNationality: "PAK",
      WorkerPassportNumber: "763564090",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2023-09-30T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2024-03-08T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2024-04-12T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments:
        "[Worker is not Active][Medical Fitness failed][Medical Fitness has expired]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "389947990489680",
      WorkerEmiratesId: "",
      WorkerFirstName: "Cord",
      WorkerLastName: "Chasmoor",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Cord Chasmoor",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "990489680",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: "2026-08-25T00:00:00",
      WorkerHseStatus: true,
      WorkerHseExpirationDate: "2023-07-27T00:00:00",
      WorkerToxicGasStatus: true,
      WorkerToxicGasExpirationDate: "2024-07-26T00:00:00",
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Medical Fitness failed]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "201712188871807",
      WorkerEmiratesId: "",
      WorkerFirstName: "Sheila-kathryn",
      WorkerLastName: "Rowena",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Sheila-kathryn Rowena",
      WorkerNationality: "BEL",
      WorkerPassportNumber: "188871807",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "561295932168740",
      WorkerEmiratesId: "",
      WorkerFirstName: "Lidia",
      WorkerLastName: "Donkersley",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Lidia Donkersley",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "932168740",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "566032748197060",
      WorkerEmiratesId: "",
      WorkerFirstName: "Saxon",
      WorkerLastName: "Errichelli",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Saxon Errichelli",
      WorkerNationality: "PAK",
      WorkerPassportNumber: "748197060",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "045755639425340",
      WorkerEmiratesId: "",
      WorkerFirstName: "Addy",
      WorkerLastName: "McCall",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Addy McCall",
      WorkerNationality: "ZAF",
      WorkerPassportNumber: "639425340",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "545765469484850",
      WorkerEmiratesId: "",
      WorkerFirstName: "Hamlen",
      WorkerLastName: "Shenton",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Hamlen Shenton",
      WorkerNationality: "ESP",
      WorkerPassportNumber: "469484850",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "553925074207770",
      WorkerEmiratesId: "",
      WorkerFirstName: "Andreana",
      WorkerLastName: "Bernath",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Andreana Bernath",
      WorkerNationality: "ESP",
      WorkerPassportNumber: "174207770",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "557545696317360",
      WorkerEmiratesId: "",
      WorkerFirstName: "Ellis",
      WorkerLastName: "Ferrick",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Ellis Ferrick",
      WorkerNationality: "NLD",
      WorkerPassportNumber: "696317360",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
    {
      Id: 0,
      LoaPortalRequestId: null,
      RequestId: null,
      SapAgreementNumber: "4700016352",
      SupplierId: "0010000122",
      WorkerEidUnifiedNumber: "562637892404950",
      WorkerEmiratesId: "",
      WorkerFirstName: "Byrann",
      WorkerLastName: "Fisher",
      WorkerFullNameEnglish: "WorkerFullNameEnglish",
      WorkerFullNameArabic: "Byrann Fisher",
      WorkerNationality: "AUT",
      WorkerPassportNumber: "892404950",
      WorkerJobTitle: "2nd Engineer",
      CompanyAr: "Comapany Example name",
      ResidencyAr: "",
      WorkerJobTitleArabic: "المهندس الثاني",
      PlaceOfIssuingResidencePermit: "",
      WorkerMedicalFitnessStatus: false,
      WorkerMedicalFitnessExpirationDate: null,
      WorkerHseStatus: false,
      WorkerHseExpirationDate: null,
      WorkerToxicGasStatus: false,
      WorkerToxicGasExpirationDate: null,
      WorkerOnboardingStatus: 1,
      WorkerOnboardingStatusComments: "[Documents not submitted]",
      CreationDate: null,
      LastUpdateDate: null,
      Note: null,
    },
  ],
};
